import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BreadcrumbItem from "Components/Atoms/BreadcrumbItem/BreadcrumbItem";
import React from "react";
import styles from './Breadcrumbs.module.sass';

const Breadcrumbs = ({children}: Props) => {
    return <div className={styles['breadcrumbs']}>
        {
            Array.isArray(children)
            ? children?.map(
                (child, idx) => (
                  (idx !== children?.length-1)
                    ? <>
                        {child}
                        <div className={styles['breadcrumbs-seperator']}>
                            <FontAwesomeIcon icon={faChevronRight} size="xs" />
                        </div>
                    </>
                    : child
                )
            )
            : children
        }
    </div>
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: React.ReactElement<typeof BreadcrumbItem>[] & any;
};

export default Breadcrumbs;